import React from 'react';
import { string } from 'prop-types';
import { Alert } from '@material-ui/lab';

import styles from './styles.scss';

const LoginErrors = ({ errors }) => {
  if (!errors) return null;
  return (
    <Alert
      classes={{ root: styles.alert }}
      severity='error'
      variant='filled'
    >
      <div>{errors}</div>
    </Alert>
  );
};

LoginErrors.propTypes = {
  errors: string,
};

export default LoginErrors;
